import { Croissant } from "lucide-react";
import { Link } from "react-router-dom";

export function Logo({ className = "", to = "/", light = false }) {
  const color = light ? "text-warmwhite" : "text-cocoa";
  return (
    <Link to={to} className={`flex items-center gap-2 group ${className}`} data-testid="brand-logo">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-terracotta text-warmwhite shadow-[0_4px_14px_rgba(189,128,106,0.4)] transition-transform duration-300 group-hover:-rotate-6">
        <Croissant strokeWidth={1.6} className="h-5 w-5" />
      </span>
      <span className={`font-serif text-2xl font-semibold tracking-tight ${color}`}>
        Oven <span className="text-terracotta">&amp;</span> Order
      </span>
    </Link>
  );
}
